import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import EditableTable from "components/smea/Table/EditableTable";
import ConfirmationModal from "modals/smea/miscellaneous/ConfirmationModal";
import useAxiosPrivate from "contexts/interceptors/axios";

export default function KSATable({
  data,
  setSelectedData,
  loadingState,
  updateTableFunction,
}) {
  const axiosPrivate = useAxiosPrivate();

  const [selectedKSASubject, setSelectedKSASubject] = useState();
  const [rowToDelete, setRowToDelete] = useState();

  const [open, setOpen] = useState(false);
  const [promptResponse, setPromptResponse] = useState(null);
  const [submit, setSubmit] = useState(false);
  const [submitKind, setSubmitKind] = useState("");
  const [promptDesc, setPromptDesc] = useState("");

  const [loading, setLoading] = useState(false);
  // const [error, setError] = useState("");

  setSelectedData(selectedKSASubject);

  useEffect(() => {
    if (rowToDelete) {
      setPromptDesc("Are you sure you want to delete this data?");
      setSubmitKind("delete");
      setOpen(true);
    }
  }, [rowToDelete]);

  useEffect(() => {
    if (!open && submit && promptResponse && rowToDelete) {
      setLoading(true);

      axiosPrivate
        .delete(`/competencies/deleteKSASubject/${rowToDelete[0]?.id}`)
        .then(() => {
          alert("KSA Subjects deleted successfully");
          setRowToDelete(null);
          setSubmit(false);
          updateTableFunction();
        })
        .catch((err) => {
          alert(err?.message);
          setRowToDelete(null);
          setSubmit(false);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [submit, promptResponse]);

  const columns = [
    // { field: "id", headerName: "ID", width: 70 },
    {
      field: "ksa",
      headerName: "KSA No",
      width: 150,
    },
    {
      field: "gradeLevel",
      headerName: "Grade Level",
      width: 150,
    },
    {
      field: "subjects",
      headerName: "Subjects",
      width: 300,
    },
  ];

  return (
    <Box sx={{ width: "100%" }}>
      <ConfirmationModal
        open={open}
        handleClose={() => setOpen(false)}
        setPromptResponse={setPromptResponse}
        setSubmit={setSubmit}
        submitKind={submitKind}
        promptDesc={promptDesc}
      />
      <EditableTable
        data={data}
        columns={columns}
        checkbox
        loading={loadingState || loading}
        singleSelect
        setSelectedData={setSelectedKSASubject}
        rowToDelete={setRowToDelete}
        height="60vh"
        remove
      />
    </Box>
  );
}
